export const GET_RC_VERSIONS = 'reportConfigurationVersions/GET_RC_VERSIONS'
